import { BaseClient } from '../client';
import { TConcessionaria } from '../dealer';
import { DealersMock } from '../dealer/dealer.mocks';

export const getAllAdminDealers = async () => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return DealersMock;
	// }

	try {
		const response = await BaseClient.get<TConcessionaria[]>(`/Admin/GetAdminConcessionarias`).then(
			(response) => response.data
		);

		return response;
	} catch (error) {
		console.error(error);
	}
};
